import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import './Navbar.css';
import overlayImage from '../../../Imagenes/Logo DPA total.png';
import overlayImage2 from '../../../Imagenes/logo_ministerio.png';

function CustomNavbar() {
  const navigate = useNavigate();
  const [showTramites, setShowTramites] = useState(false);
  const [showQuienesSomos, setShowQuienesSomos] = useState(false);

  return (
    <Navbar bg="white" expand="lg" className="shadow-sm custom-navbar">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img src={overlayImage} alt="Logo DPA" style={{ height: 50 }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarMenu" />
        <Navbar.Collapse id="navbarMenu">
          <Nav className="mx-auto">
            <Nav.Link as={Link} to="/">Inicio</Nav.Link>
            {/*<NavDropdown
              title={
                <span
                  className="tramites-dropdown-title"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/tramites');
                  }}
                >
                  Tramites
                </span>
              }
              id="tramites-dropdown"
              className="navbar-tramites-dropdown"
              show={showTramites}
              onMouseEnter={() => setShowTramites(true)}
              onMouseLeave={() => setShowTramites(false)}
              onToggle={() => {}}
            >
              <NavDropdown.Item as={Link} to="/presentacion">Presentacion de documentacion</NavDropdown.Item>
            </NavDropdown>*/}
            <Nav.Link as={Link} to="/presentacion">Tramites</Nav.Link>
            <Nav.Link as={Link} to="/licitaciones">Licitaciones</Nav.Link>
            <Nav.Link as={Link} to="/gis">SIG</Nav.Link>
            <NavDropdown
              title={
                <span
                  className="tramites-dropdown-title"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/quienes-somos');
                  }}
                >
                  Quienes Somos
                </span>
              }
              id="quienes-somos-dropdown"
              className="navbar-tramites-dropdown"
              show={showQuienesSomos}
              onMouseEnter={() => setShowQuienesSomos(true)}
              onMouseLeave={() => setShowQuienesSomos(false)}
              onToggle={() => {}}
            >
              <NavDropdown.Item as={Link} to="/mision">Mision</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/funciones">Funciones</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/autoridades">Autoridades</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/contactos">Contactos</Nav.Link>
            <Nav.Link href="https://claronet.mail2world.com/app/" target="_blank" rel="noopener noreferrer">Webmail</Nav.Link>
          </Nav>

          <div className="d-flex align-items-center gap-3 ms-auto">
            {/* Acceso Empleados oculto temporalmente en produccion */}
            <span className="navbar-text">
              <img src={overlayImage2} alt="Logo Ministerio" style={{ height: 70 }} />
            </span>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
